module.exports = __webpack_public_path__ + "img/sdg2.a7aa47f8.svg";